module.exports = __webpack_public_path__ + "static/media/dogs-other.1abf5184.png";